(function () {
  'use strict';

  /* Keeps the multi-bay ladder's figures in the same VAT mode as the
     rest of the page, to the penny. The ladder is server-rendered inc
     VAT (the store's canonical price) with pence in data attributes;
     this file only re-displays them. It never owns the VAT rate: the
     divisor is learned from the page's own main price, which the VAT &
     Tax Switcher app rewrites in place (.finalPrice text = current mode,
     data-original-price = inc VAT).

     That displayed/original pair carries penny-rounding noise
     (35.99 / 29.99 = 1.20007, not 1.2), and applying it raw made this
     ladder say "5 bays £133.32" while the 5 Bay Deal's own page says
     £133.33. So the learned divisor is snapped to a 0.5% grid (k/200)
     and every ex-VAT figure is computed as round(pence * 200 / k) in
     integer maths — the same round-half-up result the app shows on the
     destination page. Per-bay and saving figures are then derived from
     those exact ex-VAT prices (per bay rounded UP, saving rounded DOWN,
     so neither is ever flattering). If the main price can't be read,
     the inc-VAT figures stay as rendered — correct by construction. */

  var FORMATTER = (typeof Intl !== 'undefined' && Intl.NumberFormat)
    ? new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' })
    : null;

  function money(pence) {
    var n = pence / 100;
    return FORMATTER ? FORMATTER.format(n) : ('£' + n.toFixed(2));
  }

  function parseMoney(text) {
    if (!text) return null;
    var m = String(text).replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  }

  /* 200 = inc VAT mode (divisor 1.000); 240 = ex VAT at 20%. */
  function currentK() {
    var el = document.querySelector('.product-info__price .finalPrice[data-original-price]') ||
      document.querySelector('.finalPrice[data-original-price]');
    if (!el) return 200;
    var inc = parseMoney(el.getAttribute('data-original-price'));
    var shown = parseMoney(el.textContent);
    if (!(inc > 0) || !(shown > 0)) return 200;
    if (Math.abs(inc - shown) < 0.01) return 200;
    var k = Math.round((inc / shown) * 200);
    return (k > 200 && k < 400) ? k : 200;
  }

  function init() {
    // The snippet is rendered twice (above / below the buy row; CSS shows
    // one per breakpoint) — keep both in step so a resize or rotation
    // never reveals stale figures.
    var roots = document.querySelectorAll('[data-rsi-bay-deals]');
    if (!roots.length) return;

    var singleInc = parseInt(roots[0].getAttribute('data-rsi-bd-single-inc'), 10) || 0;
    var prices = document.querySelectorAll('[data-rsi-bay-deals] [data-rsi-bd-inc]');
    var perBays = document.querySelectorAll('[data-rsi-bay-deals] [data-rsi-bd-perbay]');
    var saves = document.querySelectorAll('[data-rsi-bay-deals] [data-rsi-bd-save]');
    var labels = document.querySelectorAll('[data-rsi-bay-deals] [data-rsi-bd-vatlabel]');
    var lastK = null;

    function paint() {
      var k = currentK();
      if (k === lastK) return;
      lastK = k;
      var conv = function (pence) { return Math.round((pence * 200) / k); };

      Array.prototype.forEach.call(prices, function (el) {
        var inc = parseInt(el.getAttribute('data-rsi-bd-inc'), 10);
        if (inc > 0) el.textContent = money(conv(inc));
      });

      Array.prototype.forEach.call(perBays, function (el) {
        var deal = parseInt(el.getAttribute('data-rsi-bd-deal-inc'), 10);
        var bays = parseInt(el.getAttribute('data-rsi-bd-bays'), 10);
        if (deal > 0 && bays > 0) el.textContent = money(Math.ceil(conv(deal) / bays));
      });

      Array.prototype.forEach.call(saves, function (el) {
        var deal = parseInt(el.getAttribute('data-rsi-bd-deal-inc'), 10);
        var bays = parseInt(el.getAttribute('data-rsi-bd-bays'), 10);
        var pounds = (deal > 0 && bays > 0 && singleInc > 0)
          ? Math.floor((conv(singleInc) * bays - conv(deal)) / 100) : 0;
        if (pounds > 0) { el.textContent = 'Save £' + pounds; el.hidden = false; }
        else { el.hidden = true; }
      });

      Array.prototype.forEach.call(labels, function (el) { el.textContent = (k > 200) ? 'ex VAT' : 'inc VAT'; });
    }

    paint();
    // The app mounts late and its state can change from the header or
    // the PDP toggle at any time — a cheap poll (same pattern as
    // rsi-pdp-vat-sync.js) is more reliable than guessing its events.
    window.setInterval(paint, 400);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.tax-switcher')) {
        window.setTimeout(paint, 60);
        window.setTimeout(paint, 300);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
